import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { Button, ButtonIcon, FetchState, FormInput, useModal } from '../../../../../../components'
import { TipoUnidadeDtoUpdate, TipoUnidadeList } from '../../core/_models'
import { createTipoUnidade, updateTipoUnidade, deleteTipoUnidade } from '../../core/_requests'
import { tipoUnidadeSchema } from './validation/tipoUnidadeSchema'
import {
  ButtonType,
  IconPaths,
  IconSize,
  showAlert,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'

export const TiposUnidadeModal = () => {
  const { fetchStates, refetch } = useModal()

  const { data: tiposUnidades = [] } = (fetchStates['tiposUnidades'] || {}) as FetchState<
    TipoUnidadeList[]
  >

  const [selected, setSelected] = useState<TipoUnidadeList | null>(null)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { nome: '' },
    validationSchema: tipoUnidadeSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true)
      try {
        showAlertLoading()
        if (selected?.id) {
          const updated: TipoUnidadeDtoUpdate = {
            id: selected.id,
            nome: values.nome,
          }
          await updateTipoUnidade(updated)
        } else {
          await createTipoUnidade(values)
        }

        showAlert({
          title: 'Sucesso',
          text: `Tipo de unidade ${selected ? 'atualizado' : 'criado'} com sucesso!`,
          icon: 'success',
        })

        refetch?.('tiposUnidades')
        setSelected(null)
        resetForm()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  const handleDelete = async (id: number) => {
    const isConfirmed = await showConfirmAlert()
    if (isConfirmed) {
      try {
        showAlertLoading()
        await deleteTipoUnidade(id)
        showAlert({
          title: 'Sucesso',
          text: `Tipo de unidade excluído com sucesso!`,
          icon: 'success',
        })
        refetch?.('tiposUnidades')
      } catch (error) {
        showError(error)
      }
    }
  }

  const { setFieldValue } = formik

  useEffect(() => {
    if (selected) setFieldValue('nome', selected.nome)
  }, [selected, setFieldValue])

  return (
    <>
      <table className='table table-row-dashed'>
        <thead>
          <tr>
            <th className='fw-bold'>Nome</th>
            <th className='fw-bold text-end'>Ações</th>
          </tr>
        </thead>

        <tbody>
          {tiposUnidades.map((tipo) => (
            <tr key={tipo.id}>
              <td>{tipo.nome}</td>

              <td className='d-flex justify-content-end'>
                <ButtonIcon
                  className='p-0 me-2'
                  icon={IconPaths.Pen}
                  disabled={formik.isSubmitting}
                  onClick={() => setSelected(tipo)}
                  iconSize={IconSize.Small}
                />
                <ButtonIcon
                  className='m-0 p-0'
                  icon={IconPaths.Trash}
                  disabled={formik.isSubmitting}
                  onClick={() => handleDelete(tipo.id)}
                  iconSize={IconSize.Small}
                />
              </td>
            </tr>
          ))}

          {tiposUnidades.length === 0 && (
            <tr>
              <td colSpan={2} className='text-center text-muted'>
                Nenhum tipo de unidade cadastrado
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <form noValidate onSubmit={formik.handleSubmit}>
        <FormInput
          formik={formik}
          label='Nome'
          name='nome'
          placeholder='Digite o nome do tipo'
          className='mb-3'
          isDisabled={formik.isSubmitting}
          isRequired
        />

        <div className='d-flex flex-end'>
          <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
            Salvar
          </Button>
        </div>
      </form>
    </>
  )
}
